<template>
  <div class="datepicker-container text-dark" :class="{'datepicker-container-100': width100}">
    <div style="width: 0px;height: 0px" v-if="!isShowInput" ref="date_input_field"></div>
    <div class="datepicker-input pointer pos-relative" v-else>
        <input :class="{'input-active': active}"
               ref="date_input_field"
               id="inputfield"
               type="text"
               readonly
               v-model="formatDate"
               @click="openDatePicker"
        />
        <div class="icon-calendar4 input-icon" v-show="!active" @click="openDatePicker"></div>
        <div class="icon-cross2 input-icon" v-show="active" @click="closeDatePicker"></div>
    </div>
    <div class="popper-child__container text-dark" ref="child_popper" v-on-clickaway="closeDatePicker" v-if="active">
      <div class="datepicker-panel no-select"
           :class="[{ 'no_weekends': !weekends }, {'datepicker-panel--show': isDropdownPopperDone}]"
           id="datepicker-panel">
        <div class="month-header overflow font-large">
          <div @click.stop="prevMonth" class="arrow left pointer"><span class="icon-arrow-left4"></span></div>
          <div @click.stop="nextMonth" class="arrow right pointer"><span class="icon-arrow-right4"></span></div>
          <p id="headline" class="center bold">{{ datePickerDateFormatted }}</p>
        </div>
        <div class="datepicker-with-weeknums">
          <div class="datepicker-with-weeknums__week-numbers">
            <ul>
              <li v-for="week in weekNumbers">{{ week }}</li>
            </ul>
          </div>
          <div class="datepicker-with-weeknums__datepicker">
            <div class="cal weekdays datepicker-cells">
              <div class="datepicker-cell weekday"
                   v-for="weekday in weekDays">
                {{
                  $filters.capitalize(weekday.substring(0, 3))
                }}
              </div>
            </div>
            <div id="calBoxContainer">
              <div id="calBox" class="datepicker-cells">
                <div :class="['datepicker-cell ' + date.dayClass, {'datepicker-cell--disabled': date.isDisabled}]"
                     v-for="date in dates[0].date"
                     :aria-label="date.date">
            <span v-if="date.show" class="number" :class="[{isToday: date.isToday, active: date.isSelected}]"
                  @click.stop="setDate(date)">{{ date.showDate }}</span>
                  <span v-else class="number"
                        :class="[{isToday: date.isToday, active: date.isSelected}]">{{ date.showDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment' // eslint-disable-line no-unused-vars
import {mixin as clickaway} from 'vue-clickaway'
import config from '../../config'
import {createPopper} from '@popperjs/core' // eslint-disable-line no-unused-vars

export default {
  name: 'DateSelector', // datepicker is not acceptable
  mixins: [clickaway],
  props: {
    popperPlacement: {
      default: 'bottom-start'
    },
    // Control date in parent to avoid mutating state
    date: {
      default () {
        return moment().utc()
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isOnlyShowFirstAndLastDateEachMonth: {
      type: Boolean,
      default: false
    },
    isShowInput: {
      type: Boolean,
      default: true
    },
    width100: {
      type: Boolean,
      default: false
    },
    minDate: {
      default: null
    },
    maxDate: {
      default: null
    }
  },
  data () {
    return {
      active: false,
      isDropdownPopperDone: false,
      chosenDate: this.date,
      datepickerDate: moment(this.date),
      weekends: config.showWeekends
    }
  },
  watch: {
    date () {
      this.chosenDate = this.date
      this.datepickerDate = moment(this.date)
    }
  },
  computed: {
    datePickerDateFormatted () {
      return moment(this.datepickerDate).locale(this.locale).format('MMMM YYYY')
    },
    urlLocale () {
      const url = window.location.host
      let locale = 'en'
      if (url.indexOf('.dk') > -1) {
        locale = 'da'
      }
      if (url.indexOf('.no') > -1) {
        locale = 'nb'
      }
      return locale
    },
    locale () {
      return this.$store.getters.locale
    },
    formatDate () {
      return moment(this.chosenDate).locale(this.locale).format('dddd DD. MMMM YYYY')
    },
    today () {
      return config.now.format('YYYY-MM-DD')
    },
    // calendar look
    weekDays () {
      let ary = moment.weekdays()
      // take sunday and place last
      let last = ary.shift()
      ary.push(last)
      return ary
    },
    dates () {
      const self = this
      let months = []
      let date = moment(this.datepickerDate).utc('MM-DD-YYYY')
      let dates = []
      // Create blank days
      let startOfWeek = date.date(1).isoWeekday()
      // if noweekends && week starts after friday do nothing
      if (!this.weekends && startOfWeek > 5) {
        // no blank days
      } else {
        for (let i = 1; i < startOfWeek; i++) {
          dates.push({
            show: false,
            showDate: '&nbsp;',
            dayClass: 'hide'
          })
        }
      }

      function isFirstOrLastDayInMonth (date) {
        // Parse the input date using Moment.js
        const momentDate = moment(date)
        // Check if the date is the first day of the month
        const isFirstDay = momentDate.date() === 1
        // Clone the date and move to the next day
        const nextDay = momentDate.clone().add(1, 'day')
        // Check if the next day is the first day of the next month, which means the input date is the last day of the current month
        const isLastDay = nextDay.date() === 1
        return isFirstDay || isLastDay
      }

      // Create dates
      for (let i = 1; i <= date.daysInMonth(); i++) {
        let thisDate = moment(date).date(i).utc('MM-DD-YYYY')
        dates.push({
          show: true,
          date: thisDate,
          showDate: thisDate.format('D'),
          dayOfWeek: thisDate.isoWeekday(),
          week: thisDate.isoWeek(),
          isToday: self.isTodayDate(thisDate),
          isSelected: self.isCurrentDate(thisDate),
          id: thisDate.format('D'),
          dayClass: 'd_' + thisDate.isoWeekday(),
          isDisabled: this.isDateDisabled(thisDate, isFirstOrLastDayInMonth)
        })
      }
      months.push({
        date: dates
      })
      return months
    },
    weekNumbers () {
      let weeks = []
      this.dates[0].date.forEach(date => {
        let idx = weeks.indexOf(date.week)
        if (idx < 0 && date.week) {
          weeks.push(date.week)
        }
      })
      return weeks
    }
  },
  methods: {
    createPopper () {
      const parentPopper = this.$refs.date_input_field
      const childPopper = this.$refs.child_popper
      document.getElementById('djs-content-container').appendChild(childPopper)
      createPopper(parentPopper, childPopper, {
        placement: this.popperPlacement,
        modifiers: [
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top', 'right', 'left']
            }
          },
          {
            name: 'offset',
            options: {
              offset: [0, 5]
            }
          }
        ]
      })
    },
    isDateDisabled (thisDate, isFirstOrLastDayInMonth) {
      if (this.isOnlyShowFirstAndLastDateEachMonth && !isFirstOrLastDayInMonth(thisDate)) {
        return true
      }
      const dayStr = moment(thisDate).format('YYYY-MM-DD')
      if (this.minDate && dayStr < moment(this.minDate).format('YYYY-MM-DD')) {
        return true
      }
      if (this.maxDate && dayStr > moment(this.maxDate).format('YYYY-MM-DD')) {
        return true
      }
      return false
    },
    openDatePicker (e) {
      this.active = true
      this.$nextTick(_ => {
        this.createPopper()
        this.isDropdownPopperDone = true
      })
    },
    closeDatePicker () {
      const self = this
      this.isDropdownPopperDone = false
      this.active = false
      this.$emit('close')
      // set datepickerDate to initaldate when closing animation is done
      setTimeout(function () {
        self.datepickerDate = moment(self.chosenDate)
      }, 100)
    },
    isCurrentDate (date) {
      let chosen = moment(this.chosenDate).format('YYYY-MM-DD')
      let datePickerDate = moment(date).format('YYYY-MM-DD')
      return chosen === datePickerDate
    },
    isTodayDate (date) {
      return moment(date).format('Y-MM-DD') === this.today
    },
    setDate (date) {
      if (date.isDisabled) {
        return
      }
      this.chosenDate = date.date
      this.$emit('changed', date.date)
      this.closeDatePicker()
    },
    prevMonth () {
      this.datepickerDate = moment(this.datepickerDate).subtract(1, 'month').date(2)
    },
    nextMonth () {
      this.datepickerDate = moment(this.datepickerDate).add(1, 'month').date(2)
    }
  },
  mounted () {
    if (this.isOpen) {
      this.$nextTick(_ => {
        this.openDatePicker()
      })
    }
  },
  beforeDestroy () {
    if (this.$refs.child_popper) {
      this.$refs.child_popper.remove()
    }
  }
}

</script>


<style scoped>

@import '../../assets/css/variables.css';

.input-active {
  border-color: var(--blue)
}

.hide {
  opacity: 0;
}

.datepicker-container {
  width: 100%;
  max-width: 350px;
}

.datepicker-container.datepicker-container-100 {
  width: 100%;
  max-width: 100%;
}

.datepicker-container.datepicker-container-100 .datepicker-input {
  max-width: 100% !important;
}

@media handheld, only screen and (min-width: 767px) {
  .datepicker-container .datepicker-input {
    min-width: 210px;
    max-width: 300px;
    width: 100%;
  }
}

.datepicker-input input {
  height: 38px;
  cursor: pointer;
  background-color: #ffffff;
}

.datepicker-panel {
  z-index: 123123123;
  width: 350px;
  min-height: 300px;
  border: 1px solid #d3dce6;
  box-shadow: 0 2px 6px #ccc;
  background: #fff;
  border-radius: 2px;
  line-height: 20px;
  margin: 0;
  opacity: 0;
  transform: translateY(-5px);
  transition: transform .25s ease;
}

.datepicker-panel--show {
  opacity: 1;
  transform: translateY(0px);
}

.datepicker-cells {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 5px;
}

.datepicker-cell {
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: calc(100% / 7);
}

.datepicker-cell.hide {
  cursor: default;
}

.datepicker-cell.hide span {
  cursor: default;
}

.no_weekends .datepicker-cell {
  width: calc(100% / 5);
}

#headline {
  font-size: 20px;
}

.month-header .arrow {
  padding: 20px;
}

.month-header .center {
  margin: 20px 0;
}

.cal {
  width: 100%;
}

.cal.weekdays {
  height: 20px;
  padding-bottom: 10px;
  height: 35px;
}

.no_weekends .cal.weekdays .weekday:nth-child(6), .no_weekends .cal.weekdays .weekday:nth-child(7) {
  display: none;
}

.newMonth {
  color: var(--orange);
}

.isToday {
  font-weight: bold;
  color: var(--orange);
}

.number {
  line-height: 35px;
  width: 38px;
  text-align: center;
  border-radius: 50%;
  margin: auto;
  border: 1px solid transparent;
  display: block;
}

.number:hover {
  border-color: var(--blue) !important;
  transition: 0.1s;
  cursor: pointer;
}

.active {
  background-color: var(--blue);
  color: white;
  display: block;
}

.datepicker-cell.datepicker-cell--disabled {
  opacity: 0.1;
  cursor: not-allowed;
}

.datepicker-cell.datepicker-cell--disabled .number {
  cursor: not-allowed;
  border-color: transparent !important;
}

.datepicker-cell.datepicker-cell--disabled .number:hover {
  border-color: transparent;
}

.newMonth.selected {
  background: red;
}

.no_weekends .Sat, .no_weekends .Sun, .no_weekends .d_6, .no_weekends .d_7 {
  display: none;
}

.cal-icon {
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 18px;
}

.datepicker-with-weeknums {
  display: flex;
  align-items: stretch;
}

.datepicker-with-weeknums__week-numbers {
  background: #edf0f5;
  padding-top: 35px;
  display: flex;
  align-items: stretch;
}

.datepicker-with-weeknums__week-numbers ul {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.datepicker-with-weeknums__week-numbers ul li {
  height: 37px;
  line-height: 35px;
  padding: 0 4px;
  font-size: 0.85rem;
  text-align: center;
}

.popper-child__container {
  z-index: 1231231123123;
}
</style>



// WEBPACK FOOTER //
// DateSelector.vue?9f032ffe